import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const flipCardDefaultVariants = {}
const flipCardCompoundVariants = []

const flipCardSlotNames = [
  [
    "root",
    "flip-card__root"
  ],
  [
    "rotator",
    "flip-card__rotator"
  ],
  [
    "face",
    "flip-card__face"
  ],
  [
    "front",
    "flip-card__front"
  ],
  [
    "back",
    "flip-card__back"
  ],
  [
    "edge",
    "flip-card__edge"
  ],
  [
    "topEdge",
    "flip-card__topEdge"
  ],
  [
    "rightEdge",
    "flip-card__rightEdge"
  ],
  [
    "bottomEdge",
    "flip-card__bottomEdge"
  ],
  [
    "leftEdge",
    "flip-card__leftEdge"
  ],
  [
    "corner",
    "flip-card__corner"
  ],
  [
    "cornerPart",
    "flip-card__cornerPart"
  ],
  [
    "topRightCorner",
    "flip-card__topRightCorner"
  ],
  [
    "bottomRightCorner",
    "flip-card__bottomRightCorner"
  ],
  [
    "bottomLeftCorner",
    "flip-card__bottomLeftCorner"
  ],
  [
    "topLeftCorner",
    "flip-card__topLeftCorner"
  ]
]
const flipCardSlotFns = /* @__PURE__ */ flipCardSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, flipCardDefaultVariants, getSlotCompoundVariant(flipCardCompoundVariants, slotName))])

const flipCardFn = memo((props = {}) => {
  return Object.fromEntries(flipCardSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const flipCardVariantKeys = []
const getVariantProps = (variants) => ({ ...flipCardDefaultVariants, ...compact(variants) })

export const flipCard = /* @__PURE__ */ Object.assign(flipCardFn, {
  __recipe__: false,
  __name__: 'flipCard',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: flipCardVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, flipCardVariantKeys)
  },
  getVariantProps
})